// extracted by mini-css-extract-plugin
export default {"container":"zK-z","topReviewHeading":"AK-z","criticalReview":"BK-z","favorableReview":"CK-z","vsSeparator":"DK-z"};